<template>
    <section class="tables">
        <vue-snotify></vue-snotify>
        <form class="forms-sample" ref="anyName" @submit.stop.prevent="onSubmit" autocomplete="off">
            <div class="row mt-5">
                <div class="col-md-12 d-flex align-items-stretch grid-margin">
                    <div class="row flex-grow">
                        <div class="col-12 grid-margin">
                            <h4 class="">Update Seminar Video</h4>
                            <div class="card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="row" style="height: 85px;">
                                                <div class="col-md-1">
                                                </div>
                                                <div class="col-md-10">
                                                    <b-form-group label="Video Link" label-for="Video Link">
                                                        <b-form-input type="text" id="SeminarVimeoLink"
                                                            name="SeminarVimeoLink" autocomplete="SeminarVimeoLink"
                                                            placeholder="Video Link "
                                                            v-model="form.SeminarVimeoLink"
                                                            :state="$v.form.SeminarVimeoLink.$dirty ? !$v.form.SeminarVimeoLink.$error : null"
                                                            aria-describedby="input-1-live-feedback">
                                                        </b-form-input>
                                                        <b-form-invalid-feedback id="input-1-live-feedback">This is a
                                                            required
                                                            field.
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-1">
                                                </div>
                                            </div>
                                            <div class="row" style="height: 85px;">
                                                <div class="col-md-1">
                                                </div>
                                                <div class="col-md-10">
                                                    <b-form-group class="active" label="Active" label-for="Active">
                                                        <b-form-checkbox id="Active" name="Active" value="1"
                                                            unchecked-value="0" v-model="form.Active"
                                                            aria-describedby="input-1-live-feedback">
                                                        </b-form-checkbox>
                                                    </b-form-group>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6"></div>
                                        <div class="col-md-6 mt-3">
                                            <b-button type="submit" variant="success" :disabled="isDisabled"
                                                class="btn float-right btn-success">
                                                <span >Update</span>
                                            </b-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </section>
</template>

<script>
import Vue from "vue";
import API from '@/api'
import { validationMixin } from "vuelidate";
import { required, minLength, email, requiredIf, sameAs, integer } from "vuelidate/lib/validators";

export default {
    name: 'Users',
    mixins: [validationMixin],
    data() {
        return {
            form: {
                SeminarID: '',
                SeminarVimeoLink: '',
                Active: 0,
            },
            isDisabled: false,
            readonly: true,
            member: {},
        };
    },
    validations: {
        form: {
            SeminarVimeoLink: {
                required,
            },
        }
    },
    mounted() {
        this.editMember();
    },
    methods: {
        onSubmit() {
            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
                return;
            }
            this.isDisabled = true;
            API.addUpdateSeminarVideos(this.form,
                data => {
                    this.isDisabled = false;
                    if (!this.form.SeminarID) {
                        if (data.status === 410) {
                            this.$showNotification(data, 'error')
                        } else {
                            this.$showNotification(data, 'success')
                            this.submitForm();
                        }
                    } else {
                        if (data.status === 200) {
                            this.$showNotification({ message: "Seminar Video Updated Successfully" }, 'success')
                            this.submitForm();
                        } else {
                            this.$showNotification({ message: "Please try again" }, 'error')
                        }
                    }
                },
                err => {
                    this.isDisabled = false;
                    console.log(err);
                    this.$showNotification({ message: "Failed system error" }, 'error')
                }
            )
        },
        editMember() {
            if (this.$route.params.user) {
                this.member = this.$route.params.user;
                this.form.SeminarVimeoLink = this.member.SeminarVimeoLink;
                this.form.Active = this.member.Active;
                this.form.SeminarID = this.member.SeminarID;
            }else{
               this.$router.push({name:'SeminarVideos'});
            }
        },
        submitForm() {
            this.$refs.anyName.reset();
        },

    }, computed: {},
}
</script>
